import { ScheduleTypes } from '.';

export const AddressSubFields: (required: boolean) => Record<string, ScheduleTypes.Option> = (required) => ({
  street: {
    label: 'Street',
    value: 'street',
    required: required,
    requiredIsNotOptional: required,
  },
  unit: {
    label: 'Unit',
    value: 'unit',
  },
  city: {
    label: 'City',
    value: 'city',
    required: required,
    requiredIsNotOptional: required,
  },
  country: {
    label: 'Country',
    value: 'country',
    required: required,
    requiredIsNotOptional: required,
  },
  state: {
    label: 'State',
    value: 'state',
    required: required,
    requiredIsNotOptional: required,
  },
  postalCode: {
    label: 'Postal Code',
    value: 'postalCode',
    required: required,
    requiredIsNotOptional: required,
  },
});

export const nonIntegratedOverrideFields = {
  firstName: {
    id: 'firstName',
    key: 'firstName',
    label: 'First Name',
    type: 'text',
    hideable: false,
    show: true,
    required: true,
    requiredIsNotOptional: true,
  },
  lastName: {
    id: 'lastName',
    key: 'lastName',
    label: 'Last Name',
    type: 'text',
    hideable: false,
    show: true,
    required: true,
    requiredIsNotOptional: true,
  },
  email: {
    id: 'email',
    key: 'email',
    label: 'Email',
    type: 'email',
    hideable: false,
    show: true,
    required: true,
    requiredIsNotOptional: true,
  },
  phoneNumber: {
    id: 'phoneNumber',
    key: 'phoneNumber',
    label: 'Phone',
    type: 'phone',
    hideable: false,
    show: true,
    required: true,
    requiredIsNotOptional: true,
  },
  note: {
    id: 'note',
    key: 'note',
    label: 'Note',
    type: 'textarea',
    hideable: true,
    show: false,
    required: false,
    requiredIsNotOptional: false,
    supportsNewUserOnly: true,
  },
  isNewUser: {
    id: 'isNewUser',
    key: 'isNewUser',
    label: 'New User',
    type: 'checkbox',
    hideable: false,
    show: true,
    required: false,
    requiredIsNotOptional: false,
  },
  birthDate: {
    id: 'birthDate',
    key: 'birthDate',
    label: 'Birth Date',
    type: 'birthDate',
    hideable: true,
    show: false,
    supportsNewUserOnly: true,
  },
  gender: {
    id: 'gender',
    key: 'gender',
    label: 'Gender',
    type: 'dropdown',
    options: [
      { value: 'male', label: 'Male' },
      { value: 'female', label: 'Female' },
      { value: 'other', label: 'Other' },
    ],
    hideable: true,
    show: false,
    supportsNewUserOnly: true,
  },
  address: {
    id: 'address',
    key: 'address',
    label: 'Address',
    type: 'address',
    hideable: true,
    show: false,
    required: false,
    requiredIsNotOptional: false,
    subFields: AddressSubFields(false),
  },
} as Record<keyof Partial<ScheduleTypes.PatientInfo>, ScheduleTypes.CustomField>;

export const overrideFields: Record<keyof Partial<ScheduleTypes.PatientInfo>, ScheduleTypes.CustomField> = {
  ...nonIntegratedOverrideFields,
  address: {
    id: 'address',
    key: 'address',
    label: 'Address',
    type: 'address',
    hideable: false,
    show: true,
    required: true,
    requiredIsNotOptional: true,
    subFields: AddressSubFields(true),
  },
};

export const customFields = [];

export const CACHE_AND_STALE_TIME_FOR_APPOINTMENT_OPENINGS = 1000 * 60 * 3; // 3 minutes

export const LOCATION_ID_HEADER = 'Location-Id';

export const API_RESPONSE_LIMIT = 50;
